import * as S from "./PreviewImage.style";

interface PreviewImageProps {
  image?: File | null;
}

export const PreviewImage = ({ image }: PreviewImageProps) => {
  return (
    <S.PreviewImageBox>
      {image && (
        <img
          height={300}
          src={URL.createObjectURL(image)}
          alt="척추 사진 미리 보기"
        />
      )}
    </S.PreviewImageBox>
  );
};
